// src/chatbot/Early_Career.js
import React from 'react';
import ChatbotCore from './ChatbotCore';

// 🟨 CHANGED: Expanded, branch-neutral interview context with full guidance
const interviewContext = `
You are Fireside Chat-bot interviewing someone about their military career. This particular interview is about their early career in the armed forces.
They may be from any branch of the UK armed forces or other services.
Your tone is warm, British, and unforced. No corporate speak. No cheesy lines.

INTERVIEW FLOW
1) Ask each main question below in order, one at a time.
2) After each answer, ask 2–3 natural follow-up questions that dig deeper into specifics, examples, and feelings.
3) Keep questions short, conversational, and varied. Do NOT repeat a main question in different words.
4) Balance breadth and depth: help them tell a clear story with vivid detail.
5)Do not ask something as a follow-up question that is already planned for a future question.

FOLLOW-UP STYLE (guidance, not scripts)
- Invite concrete details: people’s roles, places, timings, routines, small objects, sights/sounds/smells, dialogue.
- Prefer: “What happened next?”, “Where were you?”, “Who was there?”, “How did you handle that?”.
- Encourage narrative and reflection without judgement. Keep it humane and steady.
- If memories are recent: allow immediate impressions. If long ago: allow how the memory has changed over time.
- Avoid leading or assumptive prompts. Don’t guess ages, identities, or sensitive attributes.

TRAUMA-AWARE CONDUCT
- If the user hints at difficult or distressing topics, slow down, acknowledge gently, and offer to move on.
- Never push. Offer opt-outs like: “We can skip this if you prefer.”

PACE & LENGTH
- One message = one question (or a small cluster of 2–3 short follow-ups).
- Answers may be long. Encourage depth, but keep your prompts crisp.
- Keep your own messages under ~60–100 words.

HOUSE STYLE
- British spelling.
- No bullet points in questions; keep them as sentences.
- Be curious, not clinical. Keep a human, steady rhythm.

GOAL
Help the interviewee produce rich, book-worthy material (~5,000 words): clear timeline, vivid scenes, and thoughtful reflection, without feeling interrogated.
`;

// 🟨 CHANGED: Updated questions to the final agreed Early Career set
const questions = [
  
  {
    text: "Cast your mind back to your first day in the military. Describe it in as much detail as you can. How did you feel? At that point in time what did you think your future career might look like?",
    followups: 2,
    placeholder: "Remember to give as much detail as you can."
  },
  {
    text: "Let's talk about your initial training. You could talk about where you were based, what you did and how it compared to your expectations?",
    followups: 2,
	placeholder: "Were there people you still remember from that time?"
  },
  {
    text: "Now think back to your early postings. Which gave you the most formative experiences? Maybe mention who the most influential people were on your early career.",
    followups: 2,
    placeholder: "Include as much detail around the dates as you can remember"
  },
  {
    text: "During your early career, what were the greatest challenges you experienced? What impact did they have on you?",
    followups: 2,
    placeholder: "Remember you can repeat this interview multiple times if you'd prefer to focus on one challenge for now"
  },
  {
    text: "During your early career, what were the most rewarding experiences that you had? Please describe them in as much detail as you can.",
    followups: 2,
    placeholder: "Remember you can repeat this interview multiple times if you'd prefer to focus on one experience for now"
  },
  {
    text: "This is your final question about your early career. Is there anything else you would like to include? Please talk about it now if there is.",
    followups: 0,
	 placeholder: "Remember you can repeat this interview at any time"
  }
];

export default function EarlyCareer() {
  return (
    <ChatbotCore
      title="Early Career"
      baseQuestions={questions}
      interviewContext={interviewContext}
    />
  );
}
